import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';
import { DataFilter } from '@core/components/dynamic-table/dynamic-table.component';
import { Interaction } from '@core/models/auxiliary-company-models';
import { Company } from '@core/models/company';
import { OperationResult } from '@core/models/operation-result';
import { User } from '@core/models/user';
import { SocialLinksPipe } from '@core/pipes/social-links.pipe';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { ApiResponse, BaseApiService } from 'src/app/api/base';

export interface CompanyInteractionReview {
  interactionReviewId: number;
  user?: User;
  interactionType: number; 
  summary?: string;
  details: string;
  interactionDate: string; 
  internalAttendees?: string;
  externalContacts?: string;
  outreachOwner?: string;
  elevatedBy?: string;
  companyDetails: Company;
  hasError: boolean;
  isValid: boolean;
  remarks?: string;
}

@Injectable({
  providedIn: 'root'
})
export class InteractionReviewService extends BaseApiService<CompanyInteractionReview> {

  constructor(authService: AuthService, router: Router, messageService: MessageService, private socialLinksPipe: SocialLinksPipe) {
    super('/v2/companies/interaction-review', authService, router, messageService);
  }

  getCompanyInteractionReviews(filter: DataFilter): Observable<ApiResponse<CompanyInteractionReview[]>> {
    return this.post("", null, filter);
  }

  transformInteractionData(interactions: CompanyInteractionReview[]) {
      return interactions.map((interaction: any) => {
        return {
          ...interaction,
          id: interaction.company.companyId,
          interactionReviewId: interaction.interactionReviewId,
          route: `/companies/details/${interaction.company.companyId}`,
          nameColumn: {
            name: interaction.company?.name,
            city: interaction.company?.primaryAddress?.city,
            country: interaction.company.primaryAddress?.countryCode,
            description: interaction.company?.description,
            route: `/companies/details/${interaction.company?.companyId}`,
            socialLinks: interaction.company != null ? this.socialLinksPipe.transform(interaction.company) : [],
          }, 
          initiator: interaction.user?.name,
          interactionDate: new Intl.DateTimeFormat('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            }).format(new Date(interaction.interactionDate)),
          agentDecision: interaction.isValid ? "Yes" : "No", 
          hasError: interaction.hasError? "Yes" : "No",
          };
      });
    }
}
